import { Component, OnInit, Input, SecurityContext, NgZone } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { GlobalMethodsService } from '../../../../../services/global-methods.service';
import { GlobalVariablesService } from '../../../../../services/global-variables.service';
import { StorageService } from '../../../../../services/commons/storage.service';
import { DefaultModalComponent } from '../../../default-modal/default-modal.component';
import { environment } from 'src/environments/environment';
import { ProfileInstallationService } from 'src/app/services/commons/profile-installation.service';
import { InstallationData } from '../../../../../models/InstallationData';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { ModalService } from '../../../../../services/commons/modal.service';

@Component({
  selector: 'app-user-manuals',
  templateUrl: './user-manuals.component.html',
  styleUrls: ['./user-manuals.component.scss'],
})
export class UserManualsComponent implements OnInit {

  public user: string;
  public urlHost = environment.URL_HOST;
  private isServiceBusy = false;


  constructor(private modalCtrl: ModalController,
    public gms: GlobalMethodsService,
    private infInstallationService: ProfileInstallationService,
    public gvs: GlobalVariablesService,
    private storage: StorageService,
    private defaultModalComponent: DefaultModalComponent,
    private translate: TranslateConfigService,
    private iab: InAppBrowser,
    private modalService: ModalService,
    public platform: Platform) {
  }

  async ngOnInit() {
    await this.gms.clearIntervalStatusInstallationEvent();
    this.user = this.gvs.user.userName;

  }

  ionViewWillEnter(){
    this.gms.analyticsTrackEvent('openScreen', {screenName: 'Manuales', contentGroup: 'Manuales'});
  }

  async dismiss(value) {
    this.modalService.hide('userManualsModal', value);
  }

  async downloadManualPanel() {
    if (this.isServiceBusy) {
      return;
    }
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      this.isServiceBusy = true;
      this.gms.loading();
      const installationData: InstallationData = await this.infInstallationService.getInstallationData(this.user, this.gvs.currentInstallation.s_ins);
     this.modalCtrl.dismiss(false, '', 'loadSpinner');
      if (installationData.panel !== '') {
        const url = installationData.panel === 'AJAX' ? environment.USER_MANUAL_AJAX : environment.USER_MANUAL_HIK;
        if (await this.platform.is('android')) {
          this.iab.create('https://docs.google.com/gview?embedded=true&url=' + url, '_system');
        } else {
          this.iab.create(url, '_system');
        }
        this.gms.analyticsTrackEvent('download', {eventCategory: 'SICOR/Descarga', eventAction: 'Accion/Descarga Manual', eventLabel: 'Panel Alarma'});
      } else {
        this.gms.analyticsTrackEvent('download', {eventCategory: 'SICOR/Descarga', eventAction: 'Error/Descarga Manual', eventLabel: 'Panel Alarma'});
        await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.notExistsManual'),
          'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
      }
      this.isServiceBusy = false;
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  async downloadManualApp() {
    if (this.isServiceBusy) {
      return;
    }
    this.isServiceBusy = true;
    if (await this.platform.is('android')) {
      this.iab.create('https://docs.google.com/gview?embedded=true&url=' + environment.MANUAL_APP, '_system');
    } else {
      this.iab.create(environment.MANUAL_APP, '_system');
    }
    this.gms.analyticsTrackEvent('download', {eventCategory: 'SICOR/Descarga', eventAction: 'Accion/Descarga Manual', eventLabel: 'APP'});
    this.isServiceBusy = false;
  }

}
